import _toArray from "@babel/runtime/helpers/toArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import update from 'immutability-helper';
import DatePicker from 'react-datepicker';
import SVG from 'react-inlinesvg';
import { postRequest, putRequest, getRequest } from '../../requestUtils';
import { isWeekday } from '../../dateUtils';
import { isMobile } from '../../screenUtils';
import { analyticsTrack } from '../../analyticsUtils';
import TimezoneSelector from '../common/TimezoneSelector';
import { minStartTime, minEndTime, maxStartTime, maxEndTime, completedAvailabilities, overlappingAvailabilities, startTimeInPastValidator, formatToRubyStyle, formatToJavaScriptStyle } from '../../scheduleInterviewUtils';
import SelectOrInviteNewCoworkers from '../common/SelectOrInviteNewCoworkers';
import checkMarkIcon from '../../../assets/images/check-mark.svg';
import arrowLeftIcon from '../../../assets/images/icons/icon-left-arrow-gray.svg';
import arrowRightIcon from '../../../assets/images/icons/icon-right-arrow.svg';
import phoneIcon from '../../../assets/images/phone-square-green.svg';
import Loading from '../common/Loading';
import './ScheduleInterviewModal.scss';
var NUM_SLOTS_REQUIRED = 2;
var utmParams = {
  source: 'introfeedback',
  medium: 'inapp',
  campaign: 'hiringmanagerintro'
};
var npsUrl = "".concat(window.location.pathname, "?prompt_nps=true&") + "utm_source=".concat(utmParams.source, "&") + "utm_medium=".concat(utmParams.medium, "&") + "utm_campaign=".concat(utmParams.campaign);

// a being the availability object/struct with date, start_time, and end_time fields.
// (All of which are Date objects)
var keyFrom = function keyFrom(a, index) {
  var date = a.date && a.date.getTime();
  var startTime = a.start_time && a.start_time.getTime();
  var endTime = a.end_time && a.end_time.getTime();
  return "".concat(date).concat(startTime).concat(endTime).concat(index);
};

// filters any incomplete availablities and converts date objects to strings.
var availabilitiesDateToString = function availabilitiesDateToString(availabilities) {
  var completeAvailabilities = completedAvailabilities(availabilities);
  return completeAvailabilities.map(function (availability) {
    return {
      date: moment(availability.date).format('YYYY-MM-DD'),
      start_time: moment(availability.start_time).format('HH:mm'),
      end_time: moment(availability.end_time).format('HH:mm')
    };
  });
};
var availabilitiesStringToDate = function availabilitiesStringToDate(availabilities) {
  // availabilities are passed in as strings and to pass them to ScheduleInterviewModal they need
  // to be JS Date objects.

  /* Note: start_time and end_time take today's date because the timepickers need to be set
    to all have the same date for the overlap checks to work (that's how they work by default when
    creating an interview, and so to edit an interview we are trying to recreate that)
    They do not take the date of the availability as one might expect.
  */
  var date = new Date();
  var availabilitiesAsDates = availabilities.map(function (avail) {
    return avail.date && avail.start_time && avail.end_time ? {
      date: moment(avail.date).toDate(),
      start_time: moment("".concat(date.toDateString(), " ").concat(avail.start_time)).toDate(),
      end_time: moment("".concat(date.toDateString(), " ").concat(avail.end_time)).toDate()
    } : {
      date: null,
      start_time: null,
      end_time: null
    };
  });
  return availabilitiesAsDates;
};

// used by default propTypes
var defaultAvailabilities = function defaultAvailabilities() {
  var defaultSlots = [];
  for (var i = 0; i < NUM_SLOTS_REQUIRED + 1; i += 1) {
    defaultSlots.push({
      date: null,
      start_time: null,
      end_time: null
    });
  }
  return defaultSlots;
};
var interviewParams = function interviewParams(props, state) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'creating';
  var sendNotifications = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var proposalResourceId = props.proposalResourceId,
    reasons = props.reasons,
    internalNotes = props.internalNotes,
    interviewReschedule = props.interviewReschedule;
  var timezone = state.timezone,
    selectedCoworkers = state.selectedCoworkers,
    newCoworkers = state.newCoworkers,
    selectedTimeSlots = state.selectedTimeSlots,
    selectedInvitationRole = state.selectedInvitationRole;
  var selectedCoworkersEmails = selectedCoworkers.map(function (coworker) {
    return coworker.value;
  });
  var baseParams = {
    interview: {
      timezone: timezone,
      availabilities: formatToRubyStyle(selectedTimeSlots),
      invited_emails: [].concat(_toConsumableArray(selectedCoworkersEmails), _toConsumableArray(newCoworkers))
    },
    project_permissions: {
      emails: newCoworkers,
      level: selectedInvitationRole
    }
  };
  var typeParams = {
    creating: {
      proposal_resource_id: proposalResourceId,
      reason: internalNotes,
      internal_feedback_ids: reasons
    },
    updating: {
      reschedule: interviewReschedule,
      send_notifications: sendNotifications
    }
  };
  return _objectSpread(_objectSpread({}, baseParams), typeParams[type]);
};
var formatTimeSlot = function formatTimeSlot(date, time) {
  return {
    date: date,
    startTime: time
  };
};
var hasMatchingTimeSlot = function hasMatchingTimeSlot(timeSlots, targetSlot) {
  return timeSlots.some(function (_ref) {
    var date = _ref.date,
      startTime = _ref.startTime;
    return date === targetSlot.date && startTime === targetSlot.startTime;
  });
};
var ScheduleInterviewModal = /*#__PURE__*/function (_Component) {
  function ScheduleInterviewModal(props) {
    var _this;
    _classCallCheck(this, ScheduleInterviewModal);
    _this = _callSuper(this, ScheduleInterviewModal, [props]);
    var isEditing = props.isEditing,
      availabilities = props.availabilities,
      selectedCoworkers = props.selectedCoworkers,
      showModal = props.showModal;
    var initialAvailabilities = isEditing ? availabilitiesStringToDate(availabilities) : defaultAvailabilities();
    _this.state = {
      availabilities: initialAvailabilities,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      selectedCoworkers: selectedCoworkers,
      newCoworkers: [],
      // !! array of strings, not objects !!
      selectedInvitationRole: 'manager',
      // default project permissions level is manager
      overlapping: [],
      startTimeInPast: false,
      showModal: showModal,
      showSendNotificationModal: false,
      currentViewIndex: 1,
      selectedTimeSlots: isEditing ? formatToJavaScriptStyle(availabilities) : [],
      isFetchingSlots: false,
      availableInterviewTimeSlots: []
    };
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleTimezoneChange = _this.handleTimezoneChange.bind(_this);
    _this.handleSelectTimeSlot = _this.handleSelectTimeSlot.bind(_this);
    _this.handleAvailabilityChange = _this.handleAvailabilityChange.bind(_this);
    _this.handleNewCoworkersChange = _this.handleNewCoworkersChange.bind(_this);
    _this.getAvailableInterviewSlot = _this.getAvailableInterviewSlot.bind(_this);
    _this.handleAddAvailabilitySlot = _this.handleAddAvailabilitySlot.bind(_this);
    _this.renderNewAvailabilitiesTable = _this.renderNewAvailabilitiesTable.bind(_this);
    _this.handleAvailabilityNavigation = _this.handleAvailabilityNavigation.bind(_this);
    _this.handleSelectedCoworkersChange = _this.handleSelectedCoworkersChange.bind(_this);
    _this.handleSelectedInvitationRoleChange = _this.handleSelectedInvitationRoleChange.bind(_this);
    return _this;
  }
  _inherits(ScheduleInterviewModal, _Component);
  return _createClass(ScheduleInterviewModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getAvailableInterviewSlot(Intl.DateTimeFormat().resolvedOptions().timeZone);
    }
  }, {
    key: "setShowModal",
    value: function setShowModal(showModal) {
      var _this$props = this.props,
        handleInterviewModalClose = _this$props.handleInterviewModalClose,
        location = _this$props.location;
      if (showModal) {
        analyticsTrack('Opened Schedule Interview Modal', {
          location: location
        });
      } else {
        handleInterviewModalClose();
      }
      this.setState({
        showModal: showModal
      });
    }
  }, {
    key: "getAvailableInterviewSlot",
    value: function () {
      var _getAvailableInterviewSlot = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(timeZone) {
        var _this$props2, availableInterviewSlotUrl, csrfToken, timezone, selectedTimeZone, _yield$getRequest, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = this.props, availableInterviewSlotUrl = _this$props2.availableInterviewSlotUrl, csrfToken = _this$props2.csrfToken;
              timezone = this.state.timezone;
              selectedTimeZone = timezone || timeZone;
              this.setState({
                isFetchingSlots: true
              });
              _context.prev = 4;
              _context.next = 7;
              return getRequest(availableInterviewSlotUrl, {
                timezone: selectedTimeZone
              }, csrfToken);
            case 7:
              _yield$getRequest = _context.sent;
              data = _yield$getRequest.data;
              this.setState({
                availableInterviewTimeSlots: data
              });
              _context.next = 14;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](4);
            case 14:
              _context.prev = 14;
              this.setState({
                isFetchingSlots: false
              });
              return _context.finish(14);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 12, 14, 17]]);
      }));
      function getAvailableInterviewSlot(_x) {
        return _getAvailableInterviewSlot.apply(this, arguments);
      }
      return getAvailableInterviewSlot;
    }()
  }, {
    key: "handleShowNotificationModal",
    value: function handleShowNotificationModal() {
      this.setState({
        showModal: false,
        showSendNotificationModal: true
      });
    }
  }, {
    key: "ableToSubmit",
    value: function ableToSubmit() {
      var _this$state = this.state,
        timezone = _this$state.timezone,
        selectedTimeSlots = _this$state.selectedTimeSlots;
      var hasValidTimezone = Boolean(timezone);
      var hasEnoughSelectedSlots = selectedTimeSlots.length >= NUM_SLOTS_REQUIRED;
      return hasValidTimezone && hasEnoughSelectedSlots;
    }
  }, {
    key: "isModalOpen",
    value: function isModalOpen() {
      var _this$state2 = this.state,
        showModal = _this$state2.showModal,
        showSendNotificationModal = _this$state2.showSendNotificationModal;
      return showModal || showSendNotificationModal;
    }
  }, {
    key: "handleTimezoneChange",
    value: function handleTimezoneChange(newTimezone) {
      var _this2 = this;
      this.setState({
        timezone: newTimezone
      }, function () {
        _this2.getAvailableInterviewSlot();
      });
    }

    // newAvailabilityField is technically a Date object for all three availability inputs
    // because we use the DatePicker component to select the interview date (obviously)
    // but also to select the start and end times of the availability window.
    //
    // For start_time and end_time fields, we only care about the time portion
    // but we must store it as a Date so it can be treated as such by the
    // DatePicker.
    //
    // Likewise, for the date field, we only care about the date portion, not the time.
  }, {
    key: "handleAvailabilityChange",
    value: function handleAvailabilityChange(newAvailabilityField, index, fieldToSet) {
      if (fieldToSet !== 'start_time' && fieldToSet !== 'end_time' && fieldToSet !== 'date') {
        return;
      }
      var availabilities = this.state.availabilities;
      var newAvailabilities = update(availabilities, _defineProperty({}, index, _defineProperty({}, fieldToSet, {
        $set: newAvailabilityField
      })));
      this.setState({
        availabilities: newAvailabilities,
        overlapping: overlappingAvailabilities(newAvailabilities),
        startTimeInPast: startTimeInPastValidator(newAvailabilities)
      });
    }
  }, {
    key: "handleAddAvailabilitySlot",
    value: function handleAddAvailabilitySlot() {
      var availabilities = this.state.availabilities;
      var newAvailabilities = update(availabilities, {
        $push: [{
          date: null,
          start_time: null,
          end_time: null
        }]
      });
      this.setState({
        availabilities: newAvailabilities
      });
    }
  }, {
    key: "handleSelectedCoworkersChange",
    value: function handleSelectedCoworkersChange(newSelection) {
      this.setState({
        selectedCoworkers: newSelection
      });
    }
  }, {
    key: "handleNewCoworkersChange",
    value: function handleNewCoworkersChange(newCoworkers) {
      this.setState({
        newCoworkers: newCoworkers
      });
    }
  }, {
    key: "handleSelectedInvitationRoleChange",
    value: function handleSelectedInvitationRoleChange(newRole) {
      this.setState({
        selectedInvitationRole: newRole
      });
    }
  }, {
    key: "handleSelectTimeSlot",
    value: function handleSelectTimeSlot(val) {
      this.setState(function (prevState) {
        var selectedTimeSlots = prevState.selectedTimeSlots;
        var exists = hasMatchingTimeSlot(selectedTimeSlots, val);
        var newSelectedTimeSlots = exists ? selectedTimeSlots.filter(function (slot) {
          return !(slot.date === val.date && slot.startTime === val.startTime);
        }) : [].concat(_toConsumableArray(selectedTimeSlots), [val]);
        return {
          selectedTimeSlots: newSelectedTimeSlots
        };
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this$props3 = this.props,
        createInterviewUrl = _this$props3.createInterviewUrl,
        csrfToken = _this$props3.csrfToken,
        showNPSOnSubmit = _this$props3.showNPSOnSubmit,
        location = _this$props3.location;

      // Preserve the query string (e.g. ?tab=proposal-review) so a full-page reload after
      // submitting lands back on the originating tab instead of defaulting to Project Details.
      var newUrl = showNPSOnSubmit ? npsUrl : "".concat(window.location.pathname).concat(window.location.search);
      var params = interviewParams(this.props, this.state);
      postRequest(createInterviewUrl, params, csrfToken).then(function () {
        analyticsTrack('Submitted Interview Request', {
          location: location
        });
        window.location.href = newUrl;
      })["catch"](function () {
        return null;
      });
    }
  }, {
    key: "handleAvailabilityNavigation",
    value: function handleAvailabilityNavigation(direction) {
      var _this$state3 = this.state,
        currentViewIndex = _this$state3.currentViewIndex,
        availableInterviewTimeSlots = _this$state3.availableInterviewTimeSlots;
      var increment = direction === 'back' ? -1 : 1;
      var newView = currentViewIndex + increment;
      if (newView >= 0 && newView < availableInterviewTimeSlots.length) {
        this.setState({
          currentViewIndex: newView
        });
      }
    }
  }, {
    key: "handleUpdateSubmission",
    value: function handleUpdateSubmission(sendNotifications) {
      if (!this.ableToSubmit()) {
        return;
      }
      var _this$props4 = this.props,
        createInterviewUrl = _this$props4.createInterviewUrl,
        csrfToken = _this$props4.csrfToken,
        location = _this$props4.location,
        interviewReschedule = _this$props4.interviewReschedule,
        interviewType = _this$props4.interviewType;
      var params = interviewParams(this.props, this.state, 'updating', sendNotifications);
      var isReschedule = interviewReschedule || interviewType === 'reschedule';
      putRequest(
      // Because this is an update action, we PUT to createInterviewUrl rather than POST
      createInterviewUrl, params, csrfToken).then(function () {
        analyticsTrack("".concat(isReschedule ? 'Reschedule' : 'Edited', " Interview Request"), {
          location: location
        });
        window.location.reload();
      })["catch"](function () {
        return null;
      });
    }
  }, {
    key: "renderModalHeading",
    value: function renderModalHeading() {
      var _this$props5 = this.props,
        isEditing = _this$props5.isEditing,
        consultantName = _this$props5.consultantName,
        interviewReschedule = _this$props5.interviewReschedule,
        interviewType = _this$props5.interviewType;
      var action = !isEditing ? 'Add' : interviewReschedule || interviewType === 'reschedule' ? 'Reschedule' : 'Edit';
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h2", {
        className: "mb-3"
      }, action, ' ', "your availability to interview", ' ', consultantName), /*#__PURE__*/React.createElement("p", {
        className: "body-text-2"
      }, "Select at least", ' ', NUM_SLOTS_REQUIRED, ' ', "days and times starting tomorrow when interviewers are available. The candidate will select from these times to book a 30 minute interview. Add times when you and participating coworker(s) are available."));
    }
  }, {
    key: "renderTimezoneSelect",
    value: function renderTimezoneSelect() {
      var _this3 = this;
      var timezone = this.state.timezone;
      return /*#__PURE__*/React.createElement("div", {
        className: "timezone-select mt-4"
      }, /*#__PURE__*/React.createElement("div", {
        className: "timezone-select-label body-text-2 medium-weight required mb-2"
      }, "Your current timezone"), /*#__PURE__*/React.createElement(TimezoneSelector, {
        onChange: function onChange(newTz) {
          return _this3.handleTimezoneChange(newTz);
        },
        selectedValue: timezone
      }));
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      var _this$state4 = this.state,
        overlapping = _this$state4.overlapping,
        startTimeInPast = _this$state4.startTimeInPast;
      if (overlapping.length === 0 && !startTimeInPast) {
        // no errors to display
        return null;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 error-message mb-3"
      }, overlapping.length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-exclamation-triangle me-2"
      })), "Make sure there are no overlaps in your availability windows before continuing!"), startTimeInPast && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-exclamation-triangle me-2"
      })), "Starting time cannot be earlier than current time!"));
    }
  }, {
    key: "renderAvailabilityRow",
    value: function renderAvailabilityRow(availability, index) {
      var _this4 = this;
      var proposalResourceId = this.props.proposalResourceId;
      var isRequired = index < NUM_SLOTS_REQUIRED;
      var dayText = '';
      var fromText = '';
      var toText = '';
      if (isMobile()) {
        dayText = 'Day';
        fromText = 'From';
        toText = 'To';
      }
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("td", {
        className: "availability-entry"
      }, /*#__PURE__*/React.createElement("p", {
        className: "".concat(isRequired && 'required', " medium-weight body-text-2")
      }, "Slot", index + 1)), /*#__PURE__*/React.createElement("td", {
        className: "availability-entry"
      }, /*#__PURE__*/React.createElement("div", {
        className: "availability-datepicker-container g-row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "g-row--always",
        htmlFor: "calendar-".concat(index, "-").concat(proposalResourceId)
      }, /*#__PURE__*/React.createElement(DatePicker, {
        id: "calendar-".concat(index, "-").concat(proposalResourceId),
        selected: availability.date,
        onChange: function onChange(newDate) {
          return _this4.handleAvailabilityChange(newDate, index, 'date');
        },
        dateFormat: "MM/dd/yyyy",
        className: "availability-datepicker",
        minDate: new Date(),
        filterDate: isWeekday // only want to make weekdays available for selection
        ,
        placeholderText: dayText
      }), /*#__PURE__*/React.createElement("span", {
        className: "input-group-addon"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-calendar adjust-center"
      }))))), /*#__PURE__*/React.createElement("td", {
        className: "availability-entry"
      }, /*#__PURE__*/React.createElement("div", {
        className: "start-time-input-container g-row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "g-row--always",
        htmlFor: "start-time-".concat(index, "-").concat(proposalResourceId)
      }, /*#__PURE__*/React.createElement(DatePicker, {
        id: "start-time-".concat(index, "-").concat(proposalResourceId),
        selected: availability.start_time,
        onChange: function onChange(newStartTime) {
          return _this4.handleAvailabilityChange(newStartTime, index, 'start_time');
        },
        showTimeSelect: true,
        showTimeSelectOnly: true,
        timeIntervals: 30,
        timeCaption: "Time",
        dateFormat: "h:mm aa",
        minTime: minStartTime(availability.date),
        maxTime: maxStartTime(availability.end_time),
        className: "start-time-datepicker",
        placeholderText: fromText
      }), /*#__PURE__*/React.createElement("span", {
        className: "input-group-addon"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-clock"
      }))))), /*#__PURE__*/React.createElement("td", {
        className: "availability-entry"
      }, /*#__PURE__*/React.createElement("div", {
        className: "end-time-input-container g-row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "g-row--always",
        htmlFor: "end-time-".concat(index, "-").concat(proposalResourceId)
      }, /*#__PURE__*/React.createElement(DatePicker, {
        id: "end-time-".concat(index, "-").concat(proposalResourceId),
        selected: availability.end_time,
        onChange: function onChange(newEndTime) {
          return _this4.handleAvailabilityChange(newEndTime, index, 'end_time');
        },
        showTimeSelect: true,
        showTimeSelectOnly: true,
        timeIntervals: 30,
        timeCaption: "Time",
        dateFormat: "h:mm aa",
        minTime: minEndTime(availability.start_time),
        maxTime: maxEndTime(),
        className: "end-time-datepicker",
        placeholderText: toText
      }), /*#__PURE__*/React.createElement("span", {
        className: "input-group-addon"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-clock"
      }))))));
    }
  }, {
    key: "renderTableHeading",
    value: function renderTableHeading() {
      var timezone = this.state.timezone;
      if (!timezone) {
        return null;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "times-select-label body-text-2 medium-weight required mt-4"
      }, "Add available times:");
    }
  }, {
    key: "renderAvailabilitiesTable",
    value: function renderAvailabilitiesTable() {
      var _this5 = this;
      var _this$state5 = this.state,
        availabilities = _this$state5.availabilities,
        timezone = _this$state5.timezone;
      if (!timezone) {
        return null;
      }
      return /*#__PURE__*/React.createElement("table", {
        className: "availabilities-table mt-2"
      }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", null, "Day:"), /*#__PURE__*/React.createElement("th", null, "Available from:"), /*#__PURE__*/React.createElement("th", null, "To:")), /*#__PURE__*/React.createElement("tr", {
        className: "with-bottom-border"
      }), availabilities.map(function (availability, index) {
        return /*#__PURE__*/React.createElement("tr", {
          key: keyFrom(availability, index),
          className: index % 2 ? 'gray-background' : '',
          id: "slot".concat(index)
        }, _this5.renderAvailabilityRow(availability, index));
      }), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        className: "availability-entry add-slot",
        colSpan: "4"
      }, /*#__PURE__*/React.createElement("a", {
        className: "body-text-2 medium-weight",
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          return _this5.handleAddAvailabilitySlot();
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-plus me-2"
      }), "Add Slot", ' ', availabilities.length + 1)))));
    }
  }, {
    key: "renderNewAvailabilitiesTable",
    value: function renderNewAvailabilitiesTable() {
      var _this6 = this;
      var _this$state6 = this.state,
        timezone = _this$state6.timezone,
        currentViewIndex = _this$state6.currentViewIndex,
        selectedTimeSlots = _this$state6.selectedTimeSlots,
        isFetchingSlots = _this$state6.isFetchingSlots,
        availableInterviewTimeSlots = _this$state6.availableInterviewTimeSlots;
      if (!timezone) return null;
      var weekKey = null;
      var tableHeader = null;
      var timeSlots = [];
      var currentView = availableInterviewTimeSlots.length > 0 ? availableInterviewTimeSlots[currentViewIndex] : [];
      if (currentView) {
        weekKey = Object.keys(currentView)[0] || [];
        if (weekKey.length) {
          var _ref2 = currentView[weekKey] || [];
          var _ref3 = _toArray(_ref2);
          tableHeader = _ref3[0];
          timeSlots = _ref3.slice(1);
        }
      }
      return /*#__PURE__*/React.createElement(Fragment, null, isFetchingSlots ? /*#__PURE__*/React.createElement(Loading, null) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "date-navigation"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        id: "date-navigation-back",
        className: "nav-button ".concat(currentViewIndex === 0 ? 'disabled' : ''),
        onClick: function onClick() {
          return _this6.handleAvailabilityNavigation('back');
        },
        disabled: currentViewIndex === 0
      }, /*#__PURE__*/React.createElement(SVG, {
        src: arrowLeftIcon,
        className: "arrow-icon"
      })), /*#__PURE__*/React.createElement("div", {
        className: "date-range"
      }, weekKey), /*#__PURE__*/React.createElement("button", {
        type: "button",
        id: "date-navigation-next",
        className: "nav-button ".concat(currentViewIndex === availableInterviewTimeSlots.length - 1 ? 'disabled' : ''),
        onClick: function onClick() {
          return _this6.handleAvailabilityNavigation('forward');
        },
        disabled: currentViewIndex === availableInterviewTimeSlots.length - 1
      }, /*#__PURE__*/React.createElement(SVG, {
        src: arrowRightIcon,
        className: "arrow-icon"
      })), /*#__PURE__*/React.createElement("button", {
        className: "today-button",
        type: "button",
        onClick: function onClick() {
          return _this6.setState({
            currentViewIndex: 1
          });
        }
      }, "Today")), /*#__PURE__*/React.createElement("div", {
        className: "table-container"
      }, /*#__PURE__*/React.createElement("table", {
        className: "scrollable-table"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, tableHeader && tableHeader.map(function (header, index) {
        return /*#__PURE__*/React.createElement("th", {
          key: "header-".concat(index)
        }, header);
      })))), /*#__PURE__*/React.createElement("div", {
        className: "scrollable-tbody"
      }, /*#__PURE__*/React.createElement("table", {
        className: "scrollable-table"
      }, /*#__PURE__*/React.createElement("tbody", null, timeSlots && timeSlots.map(function (timeSlotRow, rowIndex) {
        return /*#__PURE__*/React.createElement("tr", {
          key: "slot-row-".concat(rowIndex)
        }, timeSlotRow.map(function (timeSlot, colIndex) {
          var isDisabled = ['passed', 'not_available', 'unavailable'].includes(timeSlot[2]);
          var isSelected = hasMatchingTimeSlot(selectedTimeSlots, formatTimeSlot(timeSlot[0], timeSlot[1]));
          return /*#__PURE__*/React.createElement("td", {
            key: "slot-".concat(rowIndex, "-").concat(colIndex)
          }, /*#__PURE__*/React.createElement("button", {
            id: "".concat(timeSlot[0], "-").concat(timeSlot[1].replace(' ', '-')),
            className: "btn-time-slot ".concat(isDisabled ? 'btn-time-slot-disabled' : isSelected ? 'btn-time-slot-selected' : 'btn-time-slot-available'),
            disabled: isDisabled,
            onClick: function onClick() {
              return _this6.handleSelectTimeSlot(formatTimeSlot(timeSlot[0], timeSlot[1]));
            }
          }, isSelected && timeSlot[2] === 'available' && /*#__PURE__*/React.createElement(SVG, {
            src: checkMarkIcon,
            className: "check-mark",
            alt: "checkmark icon"
          }), timeSlot[2] === 'not_available' && /*#__PURE__*/React.createElement(SVG, {
            src: phoneIcon,
            className: "check-mark",
            alt: "phone icon"
          }), /*#__PURE__*/React.createElement("span", null, timeSlot[1])));
        }));
      })))), /*#__PURE__*/React.createElement("table", {
        className: "scrollable-table"
      }, /*#__PURE__*/React.createElement("tfoot", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
        className: "btn-time-slot btn-time-slot-disabled"
      }, /*#__PURE__*/React.createElement("span", null, "Unavailable Slots"))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
        className: "btn-time-slot btn-time-slot-available"
      }, /*#__PURE__*/React.createElement("span", null, "Available Slots"))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
        className: "btn-time-slot btn-time-slot-selected"
      }, /*#__PURE__*/React.createElement(SVG, {
        src: checkMarkIcon,
        className: "check-mark",
        alt: "checkmark icon"
      }), /*#__PURE__*/React.createElement("span", null, "Selected Slots"))), /*#__PURE__*/React.createElement("td", {
        colSpan: 2
      }, /*#__PURE__*/React.createElement("div", {
        className: "btn-time-slot btn-time-slot-disabled"
      }, /*#__PURE__*/React.createElement(SVG, {
        src: phoneIcon,
        className: "check-mark",
        alt: "phone icon"
      }), /*#__PURE__*/React.createElement("span", null, "Upcoming Interivews")))))))));
    }
  }, {
    key: "renderInviteColleagues",
    value: function renderInviteColleagues() {
      var _this$props6 = this.props,
        consultantName = _this$props6.consultantName,
        invitableRoles = _this$props6.invitableRoles,
        possibleInterviewers = _this$props6.possibleInterviewers,
        excludedInterviewInvitees = _this$props6.excludedInterviewInvitees,
        isEditing = _this$props6.isEditing,
        disableAvailabilitySelection = _this$props6.disableAvailabilitySelection;
      var _this$state7 = this.state,
        selectedCoworkers = _this$state7.selectedCoworkers,
        newCoworkers = _this$state7.newCoworkers,
        selectedInvitationRole = _this$state7.selectedInvitationRole;
      if (!this.ableToSubmit()) {
        // don't show optional invite colleagues section
        // (unless able to submit)
        return null;
      }
      var excludedList;
      if (!isEditing && possibleInterviewers.current_user_permission) {
        excludedList = [possibleInterviewers.current_user_permission.email];
      } else {
        excludedList = excludedInterviewInvitees;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "mb-50 invite-colleagues-container"
      }, !disableAvailabilitySelection && /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
        className: "invite-colleagues-header mb-4"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "normal-weight mb-2"
      }, /*#__PURE__*/React.createElement("strong", null, "Invite coworkers to participate in this interview"), "\xA0\xA0(Optional)"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, "Coworkers will be notified with updates regarding the interview with", ' ', consultantName)), /*#__PURE__*/React.createElement("div", {
        className: "invite-colleagues-container mb-3"
      }, /*#__PURE__*/React.createElement(SelectOrInviteNewCoworkers, {
        invitableRoles: invitableRoles,
        allCoworkers: possibleInterviewers,
        excluded: excludedList,
        onChangeExistingCoworkers: this.handleSelectedCoworkersChange,
        selectedCoworkers: selectedCoworkers,
        onChangeNewCoworkers: this.handleNewCoworkersChange,
        newCoworkers: newCoworkers,
        onChangeNewCoworkersRole: this.handleSelectedInvitationRoleChange,
        selectedInvitationRole: selectedInvitationRole
      })));
    }
  }, {
    key: "renderSubmitButton",
    value: function renderSubmitButton() {
      var _this7 = this;
      var _this$props7 = this.props,
        isEditing = _this$props7.isEditing,
        interviewReschedule = _this$props7.interviewReschedule;
      var disabled = !this.ableToSubmit();
      var tooltipCopy = "".concat(NUM_SLOTS_REQUIRED, " slots and a timezone are required in order to submit");
      var buttonCopy = isEditing || interviewReschedule ? 'Save changes' : 'Submit availability';
      var onSubmit = isEditing || interviewReschedule ? function () {
        return !disabled && _this7.handleShowNotificationModal();
      } : function () {
        return !disabled && _this7.handleSubmit();
      };
      var submitButton = function submitButton() {
        return /*#__PURE__*/React.createElement("button", {
          className: "btn btn-primary submit-button ".concat(disabled && 'disabled'),
          onClick: onSubmit
          // can't use disabled prop here because a disabled button also disables the OverlayTrigger
          // instead, we prefer to check !disabled ourselves
        }, buttonCopy);
      };
      var possiblyWrappedButton = function possiblyWrappedButton() {
        return disabled ? /*#__PURE__*/React.createElement(OverlayTrigger, {
          placement: "left",
          delay: 200,
          overlay: /*#__PURE__*/React.createElement(Tooltip, {
            id: "cannot-submit-tooltip"
          }, tooltipCopy)
        }, submitButton()) : submitButton();
      };
      return /*#__PURE__*/React.createElement("div", {
        className: "submit-button-container g-row--always g-row-justify-right g-flex-align-center"
      }, possiblyWrappedButton());
    }
  }, {
    key: "renderModalTrigger",
    value: function renderModalTrigger() {
      var _this8 = this;
      var _this$props8 = this.props,
        modalTriggerCopy = _this$props8.modalTriggerCopy,
        modalTriggerClassName = _this$props8.modalTriggerClassName,
        modalTriggerType = _this$props8.modalTriggerType,
        introductionRequested = _this$props8.introductionRequested;
      var className = modalTriggerClassName;
      var isButton = modalTriggerType === 'button';
      var triggerCopy = modalTriggerCopy;
      if (isButton) {
        var btnType = introductionRequested ? 'btn-secondary' : 'btn-primary';
        return /*#__PURE__*/React.createElement("button", {
          className: "btn ".concat(btnType, " ").concat(className),
          onClick: function onClick() {
            return _this8.setShowModal(true);
          }
        }, triggerCopy);
      }
      return /*#__PURE__*/React.createElement("a", {
        role: "button",
        tabIndex: 0,
        className: className,
        onClick: function onClick() {
          return _this8.setShowModal(true);
        }
      }, triggerCopy);
    }
  }, {
    key: "renderModal",
    value: function renderModal() {
      var _this9 = this;
      var disableAvailabilitySelection = this.props.disableAvailabilitySelection;
      return /*#__PURE__*/React.createElement(Modal, {
        show: this.state.showModal,
        onHide: function onHide() {
          return _this9.setShowModal(false);
        },
        dialogClassName: "get-interview-in-progress-modal",
        size: "xl"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement("div", {
        className: "padded-modal-content style-guide"
      }, !disableAvailabilitySelection && /*#__PURE__*/React.createElement(Fragment, null, this.renderModalHeading(), this.renderTimezoneSelect(), this.renderNewAvailabilitiesTable(), this.renderErrors()), this.renderInviteColleagues(), this.renderSubmitButton()));
    }
  }, {
    key: "renderSendNotificationModal",
    value: function renderSendNotificationModal() {
      var _this10 = this;
      return /*#__PURE__*/React.createElement(Modal, {
        show: this.state.showSendNotificationModal,
        onHide: function onHide() {
          return _this10.setState({
            showModal: true,
            showSendNotificationModal: false
          });
        },
        dialogClassName: "send-notification-modal",
        size: "lg"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement("div", {
        className: "send-notification-modal-content style-guide"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-4"
      }, "Would you like to send notification emails to your coworkers participating in this meeting?"), /*#__PURE__*/React.createElement("div", {
        className: "send-notification-modal-actions"
      }, /*#__PURE__*/React.createElement("a", {
        role: "button",
        tabIndex: "0",
        onClick: function onClick() {
          return _this10.setState({
            showModal: true,
            showSendNotificationModal: false
          });
        },
        className: "gray back-button body-text-2 medium-weight"
      }, "Back to editing"), /*#__PURE__*/React.createElement("a", {
        role: "button",
        tabIndex: "0",
        onClick: function onClick() {
          return _this10.handleUpdateSubmission(false);
        },
        className: "send-without-notifications body-text-2 medium-weight"
      }, "Save changes + don't send emails"), /*#__PURE__*/React.createElement("a", {
        role: "button",
        tabIndex: "0",
        onClick: function onClick() {
          return _this10.handleUpdateSubmission(true);
        },
        className: "send-with-notifications body-text-2 medium-weight"
      }, "Save changes + send emails"))));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "get-interview-in-progress-modal-container"
      }, this.props.showModalTrigger && this.renderModalTrigger(), this.renderModal(), this.props.isEditing && this.renderSendNotificationModal());
    }
  }]);
}(Component);
ScheduleInterviewModal.propTypes = {
  createInterviewUrl: PropTypes.string.isRequired,
  proposalResourceId: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  consultantName: PropTypes.string.isRequired,
  showNPSOnSubmit: PropTypes.bool,
  possibleInterviewers: PropTypes.shape({
    current_user_permission: PropTypes.shape({}),
    team_members: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  invitableRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  introductionRequested: PropTypes.bool,
  modalTriggerType: PropTypes.oneOf(['button', 'link']),
  modalTriggerCopy: PropTypes.string,
  modalTriggerClassName: PropTypes.string,
  availabilities: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string,
    start_time: PropTypes.string,
    end_time: PropTypes.string
  })),
  selectedCoworkers: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })),
  excludedInterviewInvitees: PropTypes.arrayOf(PropTypes.string),
  // can be emails or names
  isEditing: PropTypes.bool,
  // tells whether to PUT or POST to createInterviewUrl
  location: PropTypes.string,
  showModal: PropTypes.bool,
  disableAvailabilitySelection: PropTypes.bool,
  showModalTrigger: PropTypes.bool,
  interviewReschedule: PropTypes.bool,
  interviewType: PropTypes.string,
  handleInterviewModalClose: PropTypes.func,
  closeOverlay: PropTypes.func
};
ScheduleInterviewModal.defaultProps = {
  introductionRequested: false,
  proposalResourceId: '',
  showNPSOnSubmit: false,
  modalTriggerType: 'button',
  modalTriggerCopy: 'Schedule Interview',
  modalTriggerClassName: 'schedule-interview-cta',
  availabilities: [],
  selectedCoworkers: [],
  isEditing: false,
  excludedInterviewInvitees: [],
  location: 'Location Not Specified',
  showModal: false,
  disableAvailabilitySelection: false,
  showModalTrigger: true,
  interviewReschedule: null,
  interviewType: null,
  handleInterviewModalClose: function handleInterviewModalClose() {},
  closeOverlay: function closeOverlay() {}
};
export default ScheduleInterviewModal;